/* Nordelle Cosmetics — global.js (StrideSafe onepager v15 base) */
(function () {
  'use strict';

  /* ---------- rolling countdown (persistent per visitor) ---------- */
  function initCountdowns() {
    var els = document.querySelectorAll('[data-countdown-duration], [data-countdown-cutoff]');
    if (!els.length) return;
    var first = els[0];
    var hours = parseFloat(first.getAttribute('data-countdown-duration'));
    if (isNaN(hours) || hours <= 0) hours = 3;
    var durationMs = Math.round(hours * 3600000);
    var KEY = 'nc_deadline_v1';
    var deadline = 0;
    try { deadline = parseInt(localStorage.getItem(KEY), 10) || 0; } catch (e) {}
    var now = Date.now();
    if (!deadline || deadline <= now || deadline > now + durationMs) {
      deadline = now + durationMs;
      try { localStorage.setItem(KEY, String(deadline)); } catch (e) {}
    }
    function tick() {
      var diff = deadline - Date.now();
      if (diff <= 0) {
        deadline = Date.now() + durationMs;
        try { localStorage.setItem(KEY, String(deadline)); } catch (e) {}
        diff = durationMs;
      }
      var h = Math.floor(diff / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      var txt = String(m).padStart(2, '0') + ' min ' + String(s).padStart(2, '0') + ' sec';
      if (h > 0) txt = h + ' h ' + txt;
      els.forEach(function (el) { el.textContent = txt; });
    }
    tick();
    setInterval(tick, 1000);
  }

  /* ---------- product gallery ---------- */
  function initGallery() {
    var main = document.querySelector('[data-gallery-main] img');
    if (!main) return;
    document.querySelectorAll('[data-gallery-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        main.src = btn.getAttribute('data-src');
        main.srcset = '';
        document.querySelectorAll('[data-gallery-thumb]').forEach(function (b) {
          b.setAttribute('aria-current', b === btn ? 'true' : 'false');
        });
      });
    });
  }

  /* ---------- variant swatches -> price + url + id ---------- */
  function initVariants() {
    var form = document.querySelector('[data-product-form]');
    if (!form) return;
    var json = document.querySelector('[data-variants-json]');
    var variants = json ? JSON.parse(json.textContent) : [];
    var idInput = form.querySelector('input[name="id"]');
    function money(cents) {
      var v = (cents / 100).toFixed(2).replace('.', ',').replace(/,00$/, ',00');
      return v.replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' kr';
    }
    form.querySelectorAll('input[name="option-color"]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        var match = variants.find(function (v) { return v.option1 === radio.value; });
        if (!match) return;
        idInput.value = match.id;
        var now = document.querySelector('[data-price-now]');
        var was = document.querySelector('[data-price-was]');
        if (now) now.textContent = money(match.price);
        if (was && match.compare_at_price) was.textContent = money(match.compare_at_price);
        var label = document.querySelector('[data-selected-color]');
        if (label) label.textContent = radio.getAttribute('data-label') || radio.value;
      });
    });
  }

  /* ---------- qty ---------- */
  function initQty() {
    document.querySelectorAll('[data-qty]').forEach(function (wrapper) {
      var input = wrapper.querySelector('input');
      wrapper.querySelectorAll('button').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var delta = btn.getAttribute('data-qty-change') === 'up' ? 1 : -1;
          input.value = Math.max(1, (parseInt(input.value, 10) || 1) + delta);
        });
      });
    });
  }

  /* ---------- sticky ATC ---------- */
  function initStickyAtc() {
    var bar = document.querySelector('[data-sticky-atc]');
    var anchor = document.querySelector('[data-atc-anchor]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      bar.classList.toggle('is-visible', !entries[0].isIntersecting);
    }, { rootMargin: '0px' });
    io.observe(anchor);
    var btn = bar.querySelector('button');
    if (btn) btn.addEventListener('click', function () {
      var submit = document.querySelector('[data-product-form] [type="submit"]');
      if (submit) submit.click();
    });
  }

  /* ---------- before / after slider ---------- */
  function initBeforeAfter() {
    document.querySelectorAll('[data-ba]').forEach(function (frame) {
      var range = frame.querySelector('.ba__range');
      var after = frame.querySelector('.ba__after');
      var handle = frame.querySelector('.ba__handle');
      if (!range || !after) return;
      range.addEventListener('input', function () {
        var v = range.value;
        after.style.clipPath = 'inset(0 0 0 ' + v + '%)';
        if (handle) handle.style.left = v + '%';
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initCountdowns();
    initGallery();
    initVariants();
    initQty();
    initStickyAtc();
    initBeforeAfter();
  });
})();

/* ---------- Funnel one-pager ---------- */
(function () {
  'use strict';

  function initBundle() {
    var tiers = document.querySelector('[data-tiers]');
    if (!tiers) return;
    var cta = document.querySelector('[data-bundle-atc]');
    var stickyLabel = document.querySelector('[data-sticky-cta-label]');
    var errorEl = document.querySelector('[data-atc-error]');
    var mainGroup = document.querySelector('[data-color-main]');
    var pickedOut = document.querySelector('[data-shade-picked]');

    function checkedTier() {
      return tiers.querySelector('input[name="fp-tier"]:checked');
    }
    function mainChecked() {
      return mainGroup ? mainGroup.querySelector('input:checked') : null;
    }

    function sync() {
      var r = checkedTier();
      tiers.querySelectorAll('[data-tier]').forEach(function (t) {
        t.classList.toggle('is-active', t.contains(r));
      });
      if (r) {
        var label = r.getAttribute('data-cta');
        if (label) {
          if (cta) cta.textContent = label;
          if (stickyLabel) stickyLabel.textContent = label;
        }
      }
    }
    tiers.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'fp-tier') sync();
    });
    sync();

    function syncMainName() {
      var m = mainChecked();
      if (m && pickedOut) pickedOut.textContent = m.getAttribute('data-shade-title') || '';
    }
    function propagateMain() {
      var m = mainChecked();
      if (!m) return;
      document.querySelectorAll('[data-tier-color]').forEach(function (sel) {
        sel.value = m.value;
        paintSwatches(sel);
      });
    }
    /* v33: nyans-swatches i paketen – den dolda selecten är fortsatt källan för varukorgen */
    function paintSwatches(sel) {
      var row = sel.parentElement;
      if (!row) return;
      var name = row.querySelector('[data-tier-swatch-name]');
      row.querySelectorAll('[data-swatch-value]').forEach(function (btn) {
        var on = btn.getAttribute('data-swatch-value') === sel.value;
        btn.classList.toggle('is-picked', on);
        btn.setAttribute('aria-checked', on ? 'true' : 'false');
        if (on && name) name.textContent = btn.getAttribute('data-swatch-title') || '';
      });
    }
    document.querySelectorAll('[data-tier-color]').forEach(function (sel) {
      var row = sel.parentElement;
      if (!row) return;
      row.querySelectorAll('[data-swatch-value]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          sel.value = btn.getAttribute('data-swatch-value');
          paintSwatches(sel);
        });
      });
      paintSwatches(sel);
    });
    var stage = document.querySelector('[data-fp-stage]');
    function jumpToVariantImage() {
      var m = mainChecked();
      if (!m || !stage) return;
      var pos = parseInt(m.getAttribute('data-media-position'), 10);
      if (!pos || pos < 1) return;
      stage.scrollTo({ left: (pos - 1) * stage.clientWidth, behavior: 'smooth' });
    }
    if (mainGroup) {
      mainGroup.addEventListener('change', function () {
        syncMainName();
        propagateMain();
        jumpToVariantImage();
      });
      syncMainName();
      propagateMain();
    }

    function collectItems() {
      var r = checkedTier();
      var qty = r ? parseInt(r.getAttribute('data-qty'), 10) || 1 : 1;
      var single = document.querySelector('[data-single-variant]');

      /* pack variant set: 1 line at exact bundle price, shades as properties */
      var packVariant = r ? r.getAttribute('data-variant') : null;
      if (packVariant) {
        var props = {};
        if (!single) {
          if (qty === 1) {
            var mp = mainChecked();
            if (!mp) return null;
            props['Nyans'] = mp.getAttribute('data-shade-title') || mp.value;
          } else {
            var activeTier = tiers.querySelector('[data-tier].is-active');
            var packSels = activeTier ? activeTier.querySelectorAll('[data-tier-color]') : [];
            if (packSels.length) {
              var pi = 0;
              packSels.forEach(function (sel) {
                pi += 1;
                var opt = sel.options[sel.selectedIndex];
                props['Nyans ' + pi] = opt ? opt.text : sel.value;
              });
            } else {
              var mp2 = mainChecked();
              if (!mp2) return null;
              props['Nyans'] = mp2.getAttribute('data-shade-title') || mp2.value;
            }
          }
        }
        return [{ id: parseInt(packVariant, 10), quantity: 1, properties: props }];
      }

      /* fallback: qty × per-unit variants */
      var map = {};
      if (single) {
        map[single.value] = qty;
      } else if (qty === 1) {
        var m = mainChecked();
        if (!m) return null;
        map[m.value] = 1;
      } else {
        var active = tiers.querySelector('[data-tier].is-active');
        var sels = active ? active.querySelectorAll('[data-tier-color]') : [];
        if (!sels.length) {
          var m2 = mainChecked();
          if (!m2) return null;
          map[m2.value] = qty;
        } else {
          sels.forEach(function (sel) {
            map[sel.value] = (map[sel.value] || 0) + 1;
          });
        }
      }
      return Object.keys(map).map(function (id) {
        return { id: parseInt(id, 10), quantity: map[id] };
      });
    }

    function addToCart() {
      var items = collectItems();
      if (!items) return;
      /* v31: gåvor – märk första raden så att ordern visar vad som ska packas */
      var giftTier = checkedTier();
      /* v34: riktiga gåvoprodukter (0 kr) som egna rader */
      var giftVariants = giftTier ? giftTier.getAttribute('data-gift-variants') : null;
      var baseItems = items.slice();
      if (giftVariants) {
        giftVariants.split(',').forEach(function (gid) {
          var n = parseInt(gid, 10);
          if (n) items.push({ id: n, quantity: 1, properties: { 'Gift': 'Included in bundle' } });
        });
      }
      var giftNote = giftTier ? giftTier.getAttribute('data-gifts') : null;
      if (giftNote && items.length) {
        items[0].properties = items[0].properties || {};
        items[0].properties['Free gifts'] = giftNote;
      }
      if (errorEl) errorEl.hidden = true;
      if (cta) cta.disabled = true;
      function postItems(list) {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: list })
        });
      }
      postItems(items)
        .then(function (res) {
          /* v34: om en gåva inte går att lägga till (slut/ej publicerad) – sälj paketet ändå */
          if (!res.ok && items.length > baseItems.length) return postItems(baseItems);
          return res;
        })
        .then(function (res) {
          if (!res.ok) {
            /* FI v8: visa Shopifys egen felorsak under felmeddelandet (lager, marknad, variant …) */
            return res.json().catch(function () { return {}; }).then(function (j) {
              var why = (j && (j.description || j.message)) || ('HTTP ' + res.status);
              if (errorEl) {
                if (!errorEl.getAttribute('data-base-text')) errorEl.setAttribute('data-base-text', errorEl.textContent);
                errorEl.textContent = errorEl.getAttribute('data-base-text') + ' (' + why + ')';
              }
              throw new Error('add failed');
            });
          }
          var goCheckout = cta && cta.getAttribute('data-checkout-url') === 'true';
          window.location.href = goCheckout ? '/checkout' : '/cart';
        })
        .catch(function () {
          if (errorEl) errorEl.hidden = false;
          if (cta) cta.disabled = false;
        });
    }

    if (cta) cta.addEventListener('click', addToCart);
    var stickyBtn = document.querySelector('[data-sticky-atc-btn]');
    if (stickyBtn) stickyBtn.addEventListener('click', addToCart);
  }

  function initLesMer() {
    document.querySelectorAll('[data-lesmer]').forEach(function (pEl) {
      var btn = pEl.parentElement.querySelector('[data-lesmer-btn]');
      if (!btn) return;
      pEl.classList.add('is-clamped');
      requestAnimationFrame(function () {
        if (pEl.scrollHeight <= pEl.clientHeight + 2) { btn.hidden = true; pEl.classList.remove('is-clamped'); }
      });
      btn.addEventListener('click', function () {
        var open = !pEl.classList.contains('is-clamped');
        pEl.classList.toggle('is-clamped', open);
        btn.textContent = open ? 'Read more' : 'Show less';
      });
    });
  }

  function initReviewMore() {
    var btn = document.querySelector('[data-review-more]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      document.querySelectorAll('.review-wall__card.is-hidden').forEach(function (c) {
        c.classList.remove('is-hidden');
      });
      btn.parentElement.hidden = true;
    });
  }

  function initBurger() {
    var btn = document.querySelector('[data-burger]');
    var menu = document.querySelector('[data-market-menu]');
    if (!btn || !menu) return;
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var open = menu.hidden;
      menu.hidden = !open;
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.classList.toggle('is-open', open);
    });
    document.addEventListener('click', function (e) {
      if (!menu.hidden && !menu.contains(e.target) && e.target !== btn) {
        menu.hidden = true;
        btn.setAttribute('aria-expanded', 'false');
        btn.classList.remove('is-open');
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initBundle();
    initLesMer();
    initReviewMore();
    initBurger();
  });
})();

/* ---------- v4: swipe gallery + lazy videos ---------- */
(function () {
  'use strict';

  function initFpCarousel() {
    var stage = document.querySelector('[data-fp-stage]');
    if (!stage) return;
    var slides = stage.querySelectorAll('[data-fp-slide]');
    var dots = document.querySelectorAll('[data-fp-dot]');
    var thumbs = document.querySelectorAll('[data-fp-thumb]');
    if (slides.length < 2) return;

    function goTo(i) {
      stage.scrollTo({ left: i * stage.clientWidth, behavior: 'smooth' });
    }
    dots.forEach(function (d) {
      d.addEventListener('click', function () { goTo(parseInt(d.getAttribute('data-fp-dot'), 10)); });
    });
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { goTo(parseInt(t.getAttribute('data-fp-thumb'), 10)); });
    });

    function setActive(i) {
      dots.forEach(function (d, j) { d.setAttribute('aria-current', j === i ? 'true' : 'false'); });
      thumbs.forEach(function (t, j) { t.setAttribute('aria-current', j === i ? 'true' : 'false'); });
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            var i = Array.prototype.indexOf.call(slides, e.target);
            if (i > -1) setActive(i);
          }
        });
      }, { root: stage, threshold: 0.6 });
      slides.forEach(function (sl) { io.observe(sl); });
    } else {
      stage.addEventListener('scroll', function () {
        setActive(Math.round(stage.scrollLeft / stage.clientWidth));
      }, { passive: true });
    }
  }

  function initLazyVideos() {
    var vids = document.querySelectorAll('.video-row__item video');
    if (!vids.length || !('IntersectionObserver' in window)) return;
    vids.forEach(function (v) { v.setAttribute('preload', 'metadata'); });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) { v.play().catch(function () {}); }
        else { v.pause(); }
      });
    }, { threshold: 0.35 });
    vids.forEach(function (v) { io.observe(v); });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initFpCarousel();
    initLazyVideos();
  });
})();

/* ---------- burger drawer ---------- */
(function () {
  'use strict';
  document.addEventListener('DOMContentLoaded', function () {
    var btn = document.querySelector('[data-menu-toggle]');
    var panel = document.querySelector('[data-menu-panel]');
    if (!btn || !panel) return;
    btn.addEventListener('click', function () {
      var open = panel.hidden;
      panel.hidden = !open;
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.classList.toggle('is-open', open);
    });
    document.addEventListener('click', function (e) {
      if (!panel.hidden && !panel.contains(e.target) && !btn.contains(e.target)) {
        panel.hidden = true;
        btn.setAttribute('aria-expanded', 'false');
        btn.classList.remove('is-open');
      }
    });
  });
})();
